import {
  Box,
  ChevronDown,
  CircuitBoard,
  MessageSquareText,
  ServerCog,
  ShieldCheck,
} from 'lucide-react'
import { useMemo, useState } from 'react'
import {
  solutionCategories,
  solutions,
  type SolutionCategory,
} from '../content/site'

const categoryIcons = {
  foundations: Box,
  operations: CircuitBoard,
  communication: MessageSquareText,
  infrastructure: ServerCog,
  continuity: ShieldCheck,
}

export function SolutionExplorer() {
  const [category, setCategory] = useState<SolutionCategory>('foundations')
  const [openId, setOpenId] = useState(solutions[0].id)
  const selectedCategory = solutionCategories.find((item) => item.id === category)
  const orderedSolutions = useMemo(
    () =>
      [...solutions].sort(
        (a, b) => Number(b.categories.includes(category)) - Number(a.categories.includes(category)),
      ),
    [category],
  )

  return (
    <section className="solution-explorer section-light" aria-labelledby="solution-explorer-title">
      <div className="solution-explorer__intro" data-reveal>
        <h2 id="solution-explorer-title">Explore the possibilities.</h2>
        <p>{selectedCategory?.description}</p>
      </div>
      <div className="solution-categories" role="tablist" aria-label="Solution categories">
        {solutionCategories.map((item) => {
          const Icon = categoryIcons[item.id]
          return (
            <button
              type="button"
              role="tab"
              aria-selected={category === item.id}
              key={item.id}
              onClick={() => setCategory(item.id)}
            >
              <Icon aria-hidden="true" strokeWidth={1.25} />
              <span>{item.label}</span>
            </button>
          )
        })}
      </div>
      <div className="solution-rows">
        {orderedSolutions.map((solution, index) => {
          const Icon = solution.icon
          const isOpen = openId === solution.id
          const isRelevant = solution.categories.includes(category)
          return (
            <article
              className="solution-row"
              id={solution.id}
              data-open={isOpen}
              data-relevant={isRelevant}
              key={solution.id}
            >
              <button
                type="button"
                className="solution-row__button"
                aria-expanded={isOpen}
                aria-controls={`${solution.id}-detail`}
                onClick={() => setOpenId(isOpen ? '' : solution.id)}
              >
                <span className="solution-row__number">
                  {String(index + 1).padStart(2, '0')}
                </span>
                <Icon aria-hidden="true" strokeWidth={1.2} />
                <span className="solution-row__title">{solution.title}</span>
                <span className="solution-row__summary">{solution.summary}</span>
                <ChevronDown aria-hidden="true" strokeWidth={1.4} />
              </button>
              <div className="solution-row__detail" id={`${solution.id}-detail`} hidden={!isOpen}>
                <p>{solution.detail}</p>
                <a href={`/contact?topic=${solution.id}`}>Discuss this area</a>
              </div>
            </article>
          )
        })}
      </div>
    </section>
  )
}
